export default "__VITE_ASSET__cTSUInGx__"